import React from 'react';
import {Notification_item_skeleton} from './notification_item_skeleton';
import styles from './notification_skeleton_loader.module.less';
import cn from 'classnames';

interface i_notification_skeleton_loader {
  is_loading: boolean;
  items?: number;
  delay?: number;
  site?: string;
  children: React.ReactNode;
}
export const Notification_skeleton_loader = ({
  is_loading,
  items = 4,
  delay = 300,
  children,
  site,
}: i_notification_skeleton_loader)=>{
  if (!is_loading)
    return <>{children}</>;
  return <div className={cn(styles.notifications_skeleton_loader,
    styles[site])}>
    {Array.from({length: items}).map((_, index)=>
      <Notification_item_skeleton
        key={index}
        delay={index * delay}
        site={site}
      />
    )}
  </div>;
};
